var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7939 14.5786H15.8905L15.5703 14.2699C16.7297 12.9251 17.3669 11.2083 17.3656 9.43282C17.3656 7.96275 16.9297 6.52569 16.113 5.30337C15.2963 4.08105 14.1354 3.12837 12.7772 2.56579C11.4191 2.00322 9.92457 1.85603 8.48275 2.14282C7.04092 2.42962 5.71652 3.13753 4.67702 4.17702C3.63753 5.21652 2.92962 6.54092 2.64282 7.98275C2.35603 9.42457 2.50322 10.9191 3.06579 12.2772C3.62837 13.6354 4.58105 14.7963 5.80337 15.613C7.02569 16.4297 8.46275 16.8656 9.93282 16.8656C11.7739 16.8656 13.4663 16.191 14.7699 15.0703L15.0786 15.3905V16.2939L20.7962 22L22.5 20.2962L16.7939 14.5786ZM9.93282 14.5786C7.08548 14.5786 4.78702 12.2802 4.78702 9.43282C4.78702 6.58548 7.08548 4.28702 9.93282 4.28702C12.7802 4.28702 15.0786 6.58548 15.0786 9.43282C15.0786 12.2802 12.7802 14.5786 9.93282 14.5786Z",
    fill: "#8B8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.a6872d2f7375bdefdb815556c9631249.svg";
export { ForwardRef as ReactComponent };